<template>
	<div class="comment_box" v-if="Comments != null && Comments !=''">
		<!--标题区-开始-->
		<div class="title_box">
			<h3>用户点评</h3>
			<a href="javascript:void(0)" @click="viewAll()">查看全部</a>
		</div>
		<!--标题区-结束-->
		
		<!--统计区-开始-->
		<div class="total_box">
			<div class="number">{{Comments.StarNumber}}</div>
			<div class="privew">
				<div class="star_group">
					<div :class="getMainStarClass(Comments.StarNumber)"></div>
				</div>
				<div class="text">来自 <b>{{Comments.Amount}}</b> 位用户点评</div>
			</div>
		</div>
		<!--统计区-结束-->
		
		<!--进度条-开始-->
		<div class="statistics">
			<ul>
				<li v-for="(item, index) in Comments.ProgressData" :key="index">
					<div class="l_star">{{item.Star}} 星</div>
					<div class="l_progress">
						<div class="bar" :style="outWidth(item.Ratio)"></div>
					</div>
					<div class="r_number">{{item.Amount}}</div>
				</li>
			</ul>
		</div>
		<!--进度条-结束-->
	</div>
</template>

<script>
	export default {
		name: 'PinglunPage',
		props: [
			'Comments',
			'DataId',
			'ColumnId'
		],
		data() {
			return {
				dialogVisible: false,
			}
		},
		methods: {
			//输出进度条
			outWidth(ratio)
			{
				return 'width:' + ratio + '%'
			},
			//返回星级Class
			getMainStarClass(star)
			{
				let cls = 'star_box s_5'
				if(star !='')
				{
					let n = Number(star)
					if(n == 5)
					{
						cls = 'star_box s_5'
					}
					else if(n<5 && n>4)
					{
						cls = 'star_box s_45'
					}
					else if(n == 4)
					{
						cls = 'star_box s_4'
					}
					else if(n<4 && n>3)
					{
						cls = 'star_box s_35'
					}
					else if(n == 3)
					{
						cls = 'star_box s_3'
					}
					else if(n<3 && n>2)
					{
						cls = 'star_box s_25'
					}
					else if(n == 2)
					{
						cls = 'star_box s_2'
					}
					else if(n<2 && n>1)
					{
						cls = 'star_box s_15'
					}
					else if(n == 1)
					{
						cls = 'star_box s_1'
					}
				}
				return cls
			},
			//返回列表星级Class
			getListStarClass(star)
			{
				if(star !='')
				{
					return 'star_box s_'+star
				}
			},
			//查看更多评论
			viewAll()
			{
				this.$emit('custom-event','这是来自子组件')
			}
		},
		created() {

		},
		beforeDestroy() {

		}
	}
</script>

<style lang="less" scoped>
	/*用户评论*/
	.comment_box {
		
		/*标题区*/
		.title_box {
			display: flex;
			justify-content: space-between;
			align-items: center;
			
			h3 {
				font-size: 18px;
				font-weight: 500;
			}
			
			a {
				display: block;
				font-size: 13px;
				font-weight: 500;
				text-decoration: underline;
				color: #3D7856;
			}
			a:hover {
				color: #333;
			}
		}
		
		/*统计区*/
		.total_box {
			margin-top: 20px;
			display: flex;
			justify-content: center;
			align-items: center;
			
			.number {
				font-size: 38px;
				line-height: 100%;
				font-weight: 500;
			}
			.privew {
				margin-left: 20px;
				
				.star_group {
					margin-top: 20px;
					display: flex;
					justify-content: center;
					
					.star_box {
						width: 136px;
						height: 20px;
						background-position: center;
						background-repeat: no-repeat;						
						background-size: auto 20px;
					}
				}
				
				.text {
					text-align: center;
					margin-top: 10px;
					font-size: 13px;
					color: #333;
				}
			}
		}
		
		/*进度条区*/
		.statistics {
			margin-top: 20px;
			font-size: 13px;
			
			ul {}

			li {
				display: flex;
				justify-content: center;
				align-items: center;
				margin: 2px 0;

				.l_star {
					width: 12%;
					text-align: right;
				}

				.l_progress {
					width: 60%;
					height: 10px;
					background: #F5F5F5;
					border-radius: 5px;
					margin: 0 6%;

					.bar {
						height: 10px;
						background: #F5A33C;
						border-radius: 5px;
					}
				}

				.r_number {
					width: 12%;
					text-align: left;
				}
			}
		}
	}
</style>